const axios = require("axios");
var createDotDangKyThiSinh = (payload) => {
	return axios
		.post(`${process.env.VUE_APP_API}${process.env.VUE_APP_DDKYTHISINH}`, {
			dotDangKyId: payload.dotDangKyId,
			thiSinhId: payload.thiSinhId,
			changeCount: payload.changeCount,
			status: payload.status,
		})
		.then((response) => response)
		.catch((error) => error.response);
};

var updateDotDangKyThiSinh = (payload) => {
	return axios
		.put(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_DDKYTHISINH}/${payload.id}`,
			{
				id: payload.id,
				dotDangKyId: payload.dotDangKyId,
				thiSinhId: payload.thiSinhId,
				changeCount: payload.changeCount + 1,
				status: payload.status,
				regCode: payload.regCode,
			},
		)
		.then((response) => response)
		.catch((error) => error.response);
};

var getDotDangKyThiSinh = ({ thiSinhId, regCode }) => {
	return axios
		.get(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_DDKYTHISINH}${process.env.VUE_APP_TRACUU}`,
			{
				params: {
					thiSinhId: thiSinhId,
					regCode: regCode,
				},
			},
		)
		.then((response) => response)
		.catch((error) => error.response);
};

export const DotDangKyThiSinhService = {
	createDotDangKyThiSinh,
	updateDotDangKyThiSinh,
	getDotDangKyThiSinh,
};
